import stylex from '@stylexjs/stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';

export const styles = stylex.create({
  inputWrapper: {
    display: 'flex',
    padding: '0px 24px',
    flexDirection: 'column',
  },
  alertTopSpacing: {
    marginTop: anatomy['size-16'],
  },
  dropdownContainer: {
    position: 'relative',
    display: 'flex',
    gap: '16px',
    width: '432px',
  },
  errorText: {
    position: 'absolute',
    bottom: '-13px',
    left: '0',
    color: colors.errorText,
    fontSize: typography['fontSizeCaption-3'],
    fontFamily: fonts.din2014Regular,
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
    zIndex: -1,
  },
  textareaErrorText: {
    position: 'absolute',
    bottom: '0px',
    left: '0',
    color: colors.errorText,
    fontSize: typography['fontSizeCaption-3'],
    fontFamily: fonts.din2014Regular,
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
    zIndex: -1,
  },
  textFieldContainer: {
    zIndex: 2,
    position: 'relative',
  },
  previewContainer: {
    marginTop: anatomy['size-24'],
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['size-4'],
    alignSelf: 'stretch',
    width: '432px',
  },
  labelPreview: {
    color: colors.secondaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['fontSizeCaption-2'],
  },
  labelPreviewText: {
    color: colors.secondaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['fontSizeCaption-2'],
    paddingTop: '16px',
  },
  labelType: {
    color: colors.secondaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['fontSizeCaption-2'],
    marginBottom: '4px',
  },
  labelTypeLocked: {
    color: palette['grey-500'],
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['fontSizeCaption-2'],
    marginBottom: '4px',
    width: '100%',
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '208px',
  },

  labelIcon: {
    width: '16px',
    height: '16px',
    position: 'relative',
    bottom: '4px',
  },

  textCountBase: {
    position: 'absolute',
    color: palette['grey-500'],
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
    top: '127px',
  },
  textCountSms: {
    right: '25px',
  },
  textCountEmail: {
    right: '25px',
  },
  lockIcon: {
    display: 'inline-flex',
    marginLeft: '6px',
    position: 'relative',
    top: '2px',
  },
  tiltapLockIcon: {
    display: 'relative',
    marginLeft: 'auto',
    transform: 'translateY(100%)',
  },
  lockedDropdownContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 12px',
    border: `1px solid ${palette['grey-100']}`,
    borderRadius: '8px',
    height: '36px',
  },
  lockedDropdownText: {
    color: colors.secondaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  dropdownIcon: {
    display: 'flex',
    alignItems: 'center',
  },
  areaPreview: {
    minHeight: '72px',
    display: 'flex',
    padding: anatomy['size-16'],
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['size-4'],
    alignSelf: 'stretch',
    borderRadius: '8px',
    background: colors.ghostBackground,
    overflow: 'auto',
    maxWidth: '432px',
  },
  messagePreview: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    color: palette['grey-700'],
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    wordBreak: 'break-all',
  },
  linkPreview: {
    color: colors.accentText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
    textDecorationLine: 'underline',
    textDecorationStyle: 'solid',
    textDecorationSkipInk: 'auto',
    textDecorationThickness: 'auto',
    textUnderlineOffset: 'auto',
    textUnderlinePosition: 'from-font',
    marginTop: 'auto',
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: anatomy['size-8'],
    padding: ' 16px 24px 16px ',
  },
  stepsContainer: {
    position: 'absolute',
    left: '24px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    alignSelf: 'stretch',
    gap: anatomy['size-12'],
  },
  stepInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  step: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
  },
  info: {
    color: colors.tertiaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightBody-5'],
  },
  nextStep: {
    color: colors.tertiaryText,
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    lineHeight: typography['lineHeightBody-5'],
  },
  dateWrapper: {
    position: 'relative',
    width: '208px',
    fontSize: '12px',
    color: colors.secondaryText,
  },
  dateWrapperLocked: {
    position: 'relative',
    width: '208px',
    fontSize: '12px',
    color: colors.secondaryText,
  },
  lockedDateContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 12px',
    border: `1px solid ${palette['grey-100']}`,
    borderRadius: '8px',
    height: '36px',
  },
  lockedDateText: {
    color: colors.secondaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  calendarIcon: {
    display: 'flex',
    alignItems: 'center',
  },
  exclamationTitle: {
    margin: 0,
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightCaption-1'],
  },
  infoLink: {
    color: colors.accentText,
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    textDecoration: 'underline',
  },
  skipTicketSendContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: anatomy['space-8'],
    marginTop: '18px',
    zIndex: 2,
  },
  skipTicketSendContainerReadonly: {
    opacity: 0.6,
    pointerEvents: 'none',
  },
  skipTicketSendText: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
  },
  skipTicketSendTextDisabled: {
    color: colors.ghostText,
  },
  message: {
    maxWidth: '432px',
    marginTop: anatomy['size-24'],
    padding: anatomy['size-12'],
    borderRadius: anatomy.borderRadiusS,
    border: `1px solid ${colors.tertiaryBorder}`,
    lineHeight: typography['lineHeightCaption-1'],
    ':not(#__unused__) > div': {
      overflow: 'visible',
    },
    zIndex: 1,
  },
  messageDisabled: {
    borderColor: colors.ghostBorder,
  },
  tiptap: {
    width: '100%',
    padding: '8px',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.primaryText,
    ':not(#__unused__) > div': {
      outline: 'none !important',
      minHeight: '60px',
    },
    ':not(#__unused__) > div > p:not(:first-child)': {
      paddingTop: anatomy['size-20'],
      minHeight: anatomy['size-20'],
      boxSizing: 'content-box',
    },
    ':not(#__unused__) a': {
      color: colors.accentText,
    },
    ':not(#__unused__) p.is-empty': {
      color: palette['grey-500'],
    },
  },
  tiptapDisabled: {
    color: palette['grey-700'],
  },
  previewText: {
    padding: 0,
    paddingLeft: anatomy['size-4'],
    ':not(#__unused__) > div': {
      minHeight: 'auto',
    },
    wordWrap: 'break-word',
  },
  informerContainer: {
    display: 'flex',
    padding: '16px',
    alignItems: 'center',
    gap: anatomy['size-8'],
    alignSelf: 'stretch',
    borderRadius: anatomy.borderRadiusM,
    background: 'var(--Background-Info, #EDF2FD)',
    marginTop: anatomy['size-8'],
  },
  informerText: {
    color: colors.primaryText,
    fontSize: typography['fontSizeBody-4'],
    lineHeight: '21px',
    width: '100%',
  },
});
